class CollectionFilter extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.productsContainer = null;
    this.clearButton = null;
    this.submitButton = null;
    this.promotedFilterCategory = null;
    this.labelView = this.getAttribute('label-view') || 'View';
  }

  connectedCallback() {
    this.form = this.querySelector('#collection-filters');
    this.productsContainer = document.getElementById('collection-products');
    this.clearButton = this.querySelector('#clear-filters');
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.promotedFilterCategory = document.getElementById('promoted-filter-category');

    // Initialize count
    const initialCount = this.productsContainer.getAttribute('data-total-products');
    if (this.submitButton) {
      this.submitButton.textContent = `${this.labelView} (${initialCount})`;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    // Add change event listeners to all form inputs
    this.form.querySelectorAll('input, select').forEach((input) => {
      input.addEventListener('change', () => {
        this.updateCollection(new FormData(this.form));
      });
    });

    // Keep the form submit handler as a fallback
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
    });

    if (this.clearButton) {
      this.clearButton.addEventListener('click', () => {
        this.form.reset();
        // Manually uncheck all checkboxes
        this.form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
          checkbox.checked = false;
        });
        this.updateCollection(new FormData(this.form));
      });
    }
  }

  updateCollection(formData) {
    const searchParams = new URLSearchParams();
    for (const pair of formData) {
      if (pair[1]) searchParams.append(pair[0], pair[1]);
    }

    fetch(`${window.location.pathname}?${searchParams.toString()}&section_id=collection`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        this.productsContainer.innerHTML = doc.querySelector('#collection-products').innerHTML;

        // Get the total products count from the response
        const totalProducts = doc.querySelector('#collection-products').getAttribute('data-total-products');
        if (this.submitButton) {
          this.submitButton.textContent = `View (${totalProducts})`;
        }
        this.productsContainer.setAttribute('data-total-products', totalProducts);

        // Update filter counts and disable/enable checkboxes
        doc.querySelectorAll('[data-filter-item]').forEach((newFilterItem) => {
          const filterName = newFilterItem.getAttribute('data-filter-name');
          const filterValue = newFilterItem.getAttribute('data-filter-value');
          const filterCount = parseInt(newFilterItem.getAttribute('data-filter-count'), 10);

          // Find the corresponding checkbox in the current form
          const checkbox = this.form.querySelector(`input[name="${filterName}"][value="${filterValue}"]`);
          if (checkbox) {
            const label = this.form.querySelector(`label[for="filter-${filterName}-${filterValue}"]`);
            // Update the count in the label
            const labelText = label.textContent.replace(/\(\d+\)/, `(${filterCount})`);
            label.textContent = labelText;

            // Disable checkbox if count is 0
            if (filterCount === 0 && !checkbox.checked) {
              checkbox.disabled = true;
              label.classList.add('opacity-50');
            } else {
              checkbox.disabled = false;
              label.classList.remove('opacity-50');
            }
          }

          // Update promoted filter category labels
          if (this.promotedFilterCategory) {
            const promotedLabel = this.promotedFilterCategory.querySelector(`label[for="filter-${filterName}-${filterValue}"]`);
            if (promotedLabel) {
              // Update the count in the promoted label
              const promotedLabelText = promotedLabel.textContent.replace(/\(\d+\)/, `(${filterCount})`);
              promotedLabel.textContent = promotedLabelText;

              // Find the corresponding checkbox in the form (drawer)
              const formCheckbox = this.form.querySelector(`input[name="${filterName}"][value="${filterValue}"]`);
              if (formCheckbox) {
                // Update checked class based on form checkbox state
                if (formCheckbox.checked) {
                  promotedLabel.classList.add('checked');
                } else {
                  promotedLabel.classList.remove('checked');
                }

                // Update disabled class
                if (filterCount === 0 && !formCheckbox.checked) {
                  promotedLabel.classList.add('disabled');
                } else {
                  promotedLabel.classList.remove('disabled');
                }
              }
            }
          }
        });

        history.pushState(
          { searchParams: searchParams.toString() },
          '',
          `${window.location.pathname}?${searchParams.toString()}`
        );

        // Re-run scroll animations for newly rendered product cards
        if (window.animateOnScroll) {
          window.animateOnScroll.cleanup();
          window.animateOnScroll.init();
        } else if (window.AnimateOnScroll) {
          window.animateOnScroll = new window.AnimateOnScroll();
        }

        // dispatch custom event to notify other components of the update
        document.dispatchEvent(new CustomEvent('collection:updated'));
      });
  }
}

customElements.define('collection-filter', CollectionFilter);
